import React, { useEffect } from "react";
import { push } from "connected-react-router";
import { reducerType } from "redux/reducers";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import HeaderBarSub from "components/HeaderBarSub";
import Container from "@material-ui/core/Container";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./styles";
import GridFullHeight from "components/GridFullHeight";
import GridFormContainer from "components/GridFormContainer";
import {
  GET_SERVICES_REDUCER,
  LOADMORE_SERVICES_REQUEST,
} from "redux/reducers/service/actionTypes";
import { SORT, DIRECTION, LIMIT, SKIP } from "common/utils";
import Loading from "components/Loading";
import MSValidatedService from "containers/MSValidatedServiceContainer";
import { ServiceProps } from "common/";
import { useTranslation } from "react-i18next";

const commonQuery = {
  sort: SORT,
  direction: DIRECTION,
  limit: LIMIT,
  skip: SKIP,
  filter: "hasDraft, isShowAll",
  hasDraft: true,
  isShowAll: true,
};

interface ManageServicesProps {
  dispatch: Dispatch;
  loading: boolean;
  services: ServiceProps[];
  loadingMore: boolean;
  canLoadmore: boolean;
}

const mapStateToProps = (state: reducerType) => {
  return {
    loading: state.service.loading,
    services: state.service.data,
    loadingMore: state.service.loadingMore,
    canLoadmore: state.service.canLoadmore,
  };
};

const ManageServices = React.memo((props: ManageServicesProps) => {
  const { dispatch, loading, services, loadingMore, canLoadmore } = props;
  const classes = styles();
  const translate = useTranslation().t;

  const openUrl = (url) => {
    dispatch(push(url));
  };

  const handleWindowScroll = () => {
    const bottomOfWindow =
      window.scrollY + window.innerHeight >= document.body.scrollHeight - 500;
    if (bottomOfWindow && !loadingMore && canLoadmore) {
      loadmoreServices();
    }
    return;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleWindowScroll);
    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  });

  useEffect(() => {
    const obj = commonQuery as any;

    dispatch({
      type: GET_SERVICES_REDUCER,
      params: obj,
      pageSize: LIMIT,
      defaultQuery: true,
    });
    // eslint-disable-next-line
  }, []);

  const loadmoreServices = () => {
    dispatch({
      type: LOADMORE_SERVICES_REQUEST,
      defaultQuery: true,
      pageSize: LIMIT,
    });
  };

  const handleSearch = (value: string) => {
    var params = { ...commonQuery };
    params["q"] = value;
    params["search"] = "name";

    dispatch({
      type: GET_SERVICES_REDUCER,
      params: params,
      pageSize: LIMIT,
      defaultQuery: true,
    });
  };

  return (
    <GridFullHeight container>
      <GridFormContainer item xs={12} sm={12} md={12}>
        <GridFullHeight container>
          <HeaderBarSub
            backUrl={"/"}
            openUrl={openUrl}
            name={translate("MANAGE_VALIDATE_SERVICES")}
            isSearch
            handleSearch={handleSearch}
          />

          {/* Handle Services List */}
          <Container className={classes.root}>
            {loading ? (
              <Loading />
            ) : (
              <>
                {services && services.length > 0 ? (
                  services.map((data, index) => (
                    <MSValidatedService
                      data={data}
                      key={index}
                      openUrl={openUrl}
                    />
                  ))
                ) : (
                  <p className={classes.noText}>
                    {translate("NO_VOLUNTEER_SERVICES")}
                  </p>
                )}
                {canLoadmore && (
                  <Container className={classes.textCenter}>
                    <CircularProgress
                      style={{ width: 25, height: 25 }}
                      className={classes.loadmore}
                    />
                  </Container>
                )}
              </>
            )}
          </Container>
        </GridFullHeight>
      </GridFormContainer>
    </GridFullHeight>
  );
});

export default connect(mapStateToProps)(ManageServices);
